import React, {
  Fragment,
  Suspense,
  useCallback,
  useContext,
  useRef,
  useState,
} from "react";
import { Fade, Zoom } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "rsuite/dist/rsuite.min.css";
import {
  Checkbox,
  FormControlLabel,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faBan,
  faBedPulse,
  faClock,
  faLayerGroup,
  faMoneyBill1Wave,
  faUsersViewfinder,
} from "@fortawesome/free-solid-svg-icons";
// import { BookingForm } from "../components/BookingForm";

import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../Loader";

import HeaderCruiseDetails from "../../../components/HeaderCruiseDetails";
import Fancybox from "../../../components/fancybox-library/Fancybox";
import { fetchCruiseExtras } from "../../../data/groupBooking/getExtraSlice";
import { fetchCheckOut } from "../../../data/groupBooking/checkOutSlice";
import { fetchCruiseDetails } from "../../../data/groupBooking/cruiseDetailsSlice";
import BookingRightSideDetails from "../../../components/BookingRightSideDetails";
import { BrandColorContext } from "../../../App";
import ItinerarySection from "../../../components/ItinerarySection";
import RoomsSection from "./RoomsSection";
import { useTranslation } from "react-i18next";
const LazyShipImageFixed = React.lazy(() =>
  import("../../../components/ShipFixedImage")
);
const CruisesDetails = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const brandColor = useContext(BrandColorContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { cruiseDetails, loading, error } = useSelector(
    (state) => state.cruiseDetails
  );
  const configuration = useSelector(
    (state) => state.configuration.configuration
  );
  const chainCode = queryParams.get("chainCode");
  const durationDay = queryParams.get("durationDay");
  const startDestId = queryParams.get("startDestId");
  const endDestId = queryParams.get("endDestId");
  const operationDate = queryParams.get("operationDate");
  const cruiseId = queryParams.get("cruiseId");
  const itineraryId = queryParams.get("itineraryId");

  const numCabins = queryParams.get("numCabins");
  const [roomData, setRoomData] = useState([
    { adultNumber: 1, childNumber: 0, childAges: [] },
  ]);
  useEffect(() => {
    const cabins = [];

    for (let i = 1; i <= numCabins; i++) {
      const adults = parseInt(queryParams.get(`adults_room_${i}`), 10) || 2;
      const children = parseInt(queryParams.get(`children_room_${i}`), 10) || 0;
      const childrenAgesParam = queryParams.get(`childAges_room_${i}`);
      const childrenAges =
        childrenAgesParam &&
          childrenAgesParam !== "undefined" &&
          childrenAgesParam !== "null"
          ? childrenAgesParam?.split(",").filter(Boolean).map(Number)
          : cruiseDetails?.request?.cabins[i - 1]?.childrenAges || [0];
      cabins.push({ cabinNumber: i, adults, children, childrenAges });
    }
    const fetchData = () => {
      const payload = {
        // chainCode,
        cruiseId,
        operationDate,
        itineraryId,
        numCabins,
        cabins,
      };
      dispatch(fetchCruiseDetails({ payload, chainCode }));
    };

    // Only fetch if data is not already present from the previous step.
    // This primarily triggers on page refresh.
    if (!cruiseDetails?.response?.cruiseName) {
      fetchData();
    }
    setRoomData(cabins);
  }, [dispatch, location.search]);

  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    // Add null check before accessing scrollHeight
    if (contentRef.current) {
      if (contentRef.current.scrollHeight > contentRef.current.clientHeight) {
        setShowButton(true);
      }
    }
  }, [cruiseDetails?.response]);

  const toggleText = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : error ? (
        <p>{error}</p>
      ) : (
        <Fragment>
          <Helmet>
            <title>
              {cruiseDetails?.response?.cruiseName ?? t("common.cruiseDetails")}
            </title>{" "}
            <style type="text/css">
              {`
                .header .header-menu .menu li a {
                  color: #051036;
                }
                .header .header-menu .menu .subnav > li > a {
                  color: #051036 !important;
                }
                .is-sticky.bg-dark-1 {
                  background-color: #fff !important;
                }
                // .is-sticky .menu li a{
                // color:#fff !important;
                // }
                .ratio-15\:9::before {
                  padding-bottom: 0 !important;
                }
                .list-disc li::marker {
                  color: ${brandColor} !important;
                }
                    
              `}
            </style>
          </Helmet>

          <section className="row d-flex items-center  mt-60  ">
            <div className="  mt-40 py-40 bg-light-2 border-top-light">
              <div className="container d-flex justify-content-between m-auto px-1    y-gap-30 items-center ">
                <div className="col-auto pe-1">
                  <Tooltip
                    arrow
                    title={
                      chainCode != "cyanegypt"
                        ? t("booking.chooseCruise")
                        : null
                    }
                  >
                    <div
                      className="d-flex items-center"
                      onClick={() =>
                        chainCode != "cyanegypt" &&
                        navigate(`/booking-cruises${location.search}`)
                      }
                      style={{
                        cursor:
                          chainCode != "cyanegypt" ? "pointer" : "default",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.color = brandColor;
                      }}
                    >
                      <div className="size-40 rounded-full flex-center bg-blue-1">
                        <i className="icon-check text-16 text-white"></i>
                      </div>
                      <div className="text-18 text-blue-1 fw-500 ml-10">
                        {t("booking.chooseCruise")}
                      </div>
                    </div>
                  </Tooltip>
                </div>{" "}
                <div className="col px-1">
                  <div className="w-full h-1 border-blue-1 bg-border"></div>
                </div>
                <div className="col-auto  px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 rounded-full flex-center bg-blue-1">
                      <span className=" text-16 text-white">2</span>
                    </div>
                    <div className="text-18 fw-500 ml-10">
                      {" "}
                      {t("booking.chooseCabin")}{" "}
                    </div>
                  </div>
                </div>
                <div className="col px-1">
                  <div className="w-full h-1 bg-border"></div>
                </div>
                {cruiseDetails?.response?.isExtrasExists && (
                  <Fragment>
                    <div className="col-auto px-1">
                      <div className="d-flex items-center">
                        <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                          3
                        </div>
                        <div className="text-18 fw-500 ml-10">
                          {t("booking.addExtra")}
                        </div>
                      </div>
                    </div>

                    <div className="col px-1">
                      <div className="w-full h-1 bg-border"></div>
                    </div>
                  </Fragment>
                )}
                <div className="col-auto px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                      {cruiseDetails?.response?.isExtrasExists ? 4 : 3}
                    </div>
                    <div className="text-18 fw-500 ml-10">
                      {t("booking.checkout")}{" "}
                    </div>
                  </div>
                </div>
                <div className="col px-1">
                  <div className="w-full h-1 bg-border"></div>
                </div>
                <div className="col-auto px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                      {cruiseDetails?.response?.isExtrasExists ? 5 : 4}
                    </div>
                    <div className="text-18 fw-500 ml-10">
                      {t("booking.bookingCompleted")}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <HeaderCruiseDetails />
          <section className="pt-30">
            <div className="container">
              <div className="row y-gap-15 justify-between items-end">
                <div className="col-auto">
                  <h1 className="text-30 fw-600">
                    {cruiseDetails?.response?.cruiseName}
                  </h1>

                  <div className="row x-gap-20 y-gap-20 items-center pt-10">
                    <div className="col-auto">
                      <div className="d-flex items-center">
                        <div
                          className="d-flex x-gap-5 items-center"
                          dangerouslySetInnerHTML={{
                            __html: cruiseDetails?.response?.ratingStarCode,
                          }}
                        />
                        <div className="text-14 text-light-1 ml-10">
                          {cruiseDetails?.response?.cruiseBrandName
                            ? cruiseDetails?.response?.cruiseBrandName
                            : null}{" "}
                        </div>
                      </div>
                    </div>

                    <div className="col-auto">
                      <div className="row x-gap-10 items-center">
                        <div className="col-auto">
                          <div className="d-flex x-gap-5 items-center">
                            <i className="icon-placeholder text-16 text-light-1"></i>
                            <div className="text-15 text-light-1">
                              {
                                cruiseDetails?.response?.itinerary
                                  .itineraryStartDest
                              }{" "}
                              -{" "}
                              {
                                cruiseDetails?.response?.itinerary
                                  .itineraryEndDest
                              }{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-auto">
                      <div className="row x-gap-10 items-center">
                        <div className="col-auto">
                          <div className="d-flex x-gap-5 items-center">
                            <FontAwesomeIcon icon={faUsersViewfinder} />
                            <div className="text-15 text-light-1">
                              {
                                cruiseDetails?.request
                                  ?.listPassengersRoomsRequests[0].adultNumber
                              }{" "}
                              Adults
                              {cruiseDetails?.request
                                ?.listPassengersRoomsRequests[0].children >
                                0 && (
                                <>
                                  {" "}
                                  &{" "}
                                  {
                                    cruiseDetails?.request
                                      ?.listPassengersRoomsRequests[0]
                                      .children
                                  }{" "}
                                  Child
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-30 pb-30 js-pin-container">
            <div className="container">
              <div className="row   y-gap-30">
                <div className="col-lg-8">
                  <div className="relative d-flex justify-center overflow-hidden gallery">
                    <Swiper
                      modules={[Navigation]}
                      slidesPerView={1} // Equivalent to `data-slider-cols="base-1"`
                      navigation={{
                        prevEl: ".js-img-prev",
                        nextEl: ".js-img-next",
                      }}
                      className="swiper-wrapper"
                    >
                      {cruiseDetails.response?.cruisePhotos?.length > 0 ? (
                        cruiseDetails.response?.cruisePhotos?.map(
                          (image, index) => (
                            <SwiperSlide key={index}>
                              <img
                                src={image}
                                alt={cruiseDetails.response?.cruiseName}
                                className="rounded-4 col-12 h-full object-cover"
                              />
                            </SwiperSlide>
                          )
                        )
                      ) : (
                        <SwiperSlide>
                          <div className="no-image-found d-flex justify-center  ">
                            <p className="text-danger">
                              {t("common.noImageFound")}
                            </p>
                          </div>
                        </SwiperSlide>
                      )}
                    </Swiper>

                    {/* Navigation Buttons */}
                    <div className="absolute h-100 col-11">
                      <button className="section-slider-nav -prev flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-img-prev">
                        <i className="icon icon-chevron-left text-12"></i>
                      </button>
                      <button className="section-slider-nav -next flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-img-next">
                        <i className="icon icon-chevron-right text-12"></i>
                      </button>
                    </div>

                    {/* Gallery Link */}
                    <div className="absolute h-full col-12 z-2 px-20 py-20 d-flex justify-end items-end">
                      <Fancybox>
                        {/* to strt from image 2  */}
                        {cruiseDetails.response?.cruisePhotos?.length > 1 ? (
                          <a
                            href={cruiseDetails.response?.cruisePhotos[0]}
                            className="button -blue-1 px-24 py-15 bg-white text-dark-1"
                            data-fancybox="main-gallery"
                            aria-label={`${t("common.galleryImage")} 1`}
                          >
                            {t("common.seeAllPhotos")}
                          </a>
                        ) : null}
                        {cruiseDetails.response?.cruisePhotos?.length > 0
                          ? cruiseDetails.response?.cruisePhotos
                            ?.slice(1)
                            ?.map((image, index) => (
                              <a
                                key={index}
                                href={image}
                                className="d-none"
                                data-fancybox="main-gallery"
                                aria-label={`${t("common.galleryImage")} ${index + 2
                                  }`}
                              ></a>
                            ))
                          : null}
                      </Fancybox>
                    </div>
                  </div>

                  <span id="overview"></span>
                  <h3 className="text-22 fw-500 pt-30">
                    {t("common.highlights")}
                  </h3>

                  <div className="row y-gap-30 justify-between pt-30 pb-30">
                    <div className="col-md-auto col-12">
                      <div className="d-flex  ">
                        <FontAwesomeIcon
                          icon={faClock}
                          className="text-20 text-blue-1 mr-10 pt-1"
                        />
                        <div className="text-15 lh-15">
                          {t("common.duration")}: <br />{" "}
                          {cruiseDetails?.response?.itinerary.itineraryName}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-auto col-12">
                      <div className="d-flex">
                        <FontAwesomeIcon
                          icon={faLayerGroup}
                          className="text-20 text-blue-1 mr-10 pt-1"
                        />
                        <div className="text-15 lh-15">
                          {t("common.decks")}: <br />{" "}
                          {cruiseDetails?.response?.deckNum} {t("common.decks")}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-auto col-12">
                      <div className="d-flex">
                        <FontAwesomeIcon
                          icon={faBedPulse}
                          className="text-20 text-blue-1 mr-10 pt-1"
                        />
                        <div className="text-15 lh-15 ">
                          {t("common.cabinsNumber")} <br />
                          {cruiseDetails?.response?.numberOfCabins}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-top-light "></div>

                  <div className="row pt-30 pb-30">
                    <div className="col-12">
                      <h3 className="text-22 fw-500">
                        {t("common.overview")}{" "}
                      </h3>

                      <div
                        className={`text-dark-1 text-15 mt-20 ${isExpanded ? "expanded" : "collapsed"
                          }`}
                        ref={contentRef}
                        style={{
                          maxHeight: isExpanded ? "none" : "3em",
                          overflow: "hidden",
                          lineHeight: "1.5em",
                        }}
                      >
                        {cruiseDetails?.response?.description ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: cruiseDetails?.response?.description,
                            }}
                          />
                        ) : (
                          <p className="text-danger">
                            {t("common.noOverviewForThisCruise")}
                          </p>
                        )}

                        {cruiseDetails?.response?.cruiseAccommodation ? (
                          <>
                            {" "}
                            <h6 className=" my-3 d-flex align-items-center  text-dark fw-400 ">
                              <i className="icon-bed text-blue-1 mr-10"></i>{" "}
                              <span>{t("common.accommodation")}</span>
                            </h6>
                            <span
                              dangerouslySetInnerHTML={{
                                __html:
                                  cruiseDetails?.response?.cruiseAccommodation,
                              }}
                            />
                          </>
                        ) : null}
                        {cruiseDetails?.response?.cruiseDining ? (
                          <>
                            {" "}
                            <h6 className=" my-3 d-flex align-items-center  text-dark fw-400 ">
                              <i className="icon-food text-blue-1 mr-10"></i>{" "}
                              <span>{t("common.dining")}</span>
                            </h6>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: cruiseDetails?.response?.cruiseDining,
                              }}
                            />
                          </>
                        ) : null}
                        {cruiseDetails?.response?.cruiseFacilities ? (
                          <>
                            {" "}
                            <h6 className=" my-3 d-flex align-items-center  text-dark fw-400 ">
                              <i className="icon-ski text-blue-1 mr-10"></i>{" "}
                              <span>{t("common.facilities")}</span>
                            </h6>
                            <span
                              dangerouslySetInnerHTML={{
                                __html:
                                  cruiseDetails?.response?.cruiseFacilities,
                              }}
                            />
                          </>
                        ) : null}
                      </div>

                      {/* Show More / Show Less button */}
                      {showButton && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleText();
                          }}
                          className="d-block text-14 text-blue-1 fw-500 underline mt-10  pb-30"
                        >
                          {isExpanded
                            ? t("common.showLess")
                            : t("common.viewMore")}
                        </button>
                      )}
                    </div>
                    {cruiseDetails?.response?.itineraryIncluded ? (
                      <div className=" border-top-light pt-30 pb-30">
                        <div className="row x-gap-40 y-gap-40  ">
                          <div className="col-12">
                            <h3 className="text-22 fw-500">
                              {t("common.whatsIncluded")}
                            </h3>

                            <div className="row x-gap-40 y-gap-40 pt-20">
                              <div className="col-md-6">
                                <div className="text-dark-1 text-15">
                                  {/* <i className="icon-check text-green-2 text-10 mr-10"></i>{" "} */}
                                  <div
                                    id="included"
                                    className="text-dark-1 text-15"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        cruiseDetails?.response
                                          ?.itineraryIncluded,
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div
                                  className="text-dark-1 text-15"
                                  id="exclude"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      cruiseDetails?.response
                                        ?.itineraryExcluded,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div id="itinerary"></div>
                    <div className="container pt-30 pb-30">
                      <div className="border-top-light"></div>
                    </div>
                    <ItinerarySection cruiseDetails={cruiseDetails} />
                  </div>
                </div>

                <div className="col-lg-4">
                  <BookingRightSideDetails cruiseDetails={cruiseDetails} />
                </div>
              </div>
            </div>
          </section>
          {configuration?.isWheelDisplayed && (
            <Suspense fallback={<div>{t("common.loading")}</div>}>
              <LazyShipImageFixed />
            </Suspense>
          )}
          <div className="pt-30">
            <div className="container">
              <div className="col-lg-9">
                <div className="container  ">
                  <div className="border-top-light"></div>
                </div>

                <RoomsSection
                  durationDay={durationDay}
                  startDestId={startDestId}
                  endDestId={endDestId}
                  chainCode={chainCode}
                  cruiseDetails={cruiseDetails}
                  cruiseId={cruiseId}
                />
                {cruiseDetails?.response?.languages.length > 0 ? (
                  <div
                    className="col-md-12 border-top-light pt-30 pb-30"
                    id="languages"
                  >
                    <h5 className="text-16 fw-500">
                      {t("common.availableLanguages")}
                    </h5>
                    <div className="text-15 mt-10">
                      {cruiseDetails?.response?.languages.map(
                        (language, index) => (
                          <span key={index}>
                            {language}{" "}
                            {index + 1 <
                              cruiseDetails?.response?.languages.length &&
                              ","}{" "}
                          </span>
                        )
                      )}
                    </div>
                  </div>
                ) : null}
                {cruiseDetails?.response?.itineraryNote ? (
                  <div className="col-12 border-top-light pt-30 pb-30">
                    <h5 className="text-16 fw-500">{t("common.notes")}</h5>
                    <div
                      className="text-dark-1 text-15"
                      dangerouslySetInnerHTML={{
                        __html: cruiseDetails?.response?.itineraryNote,
                      }}
                    />
                  </div>
                ) : null}
                {cruiseDetails?.response?.cancellationPolicy?.length > 0 ? (
                  <div
                    className="col-md-12 border-top-light pt-30 pb-30"
                    id="cancellation-policy"
                  >
                    <h5 className="text-16 fw-500">
                      {t("common.cancellationPolicy")}
                    </h5>
                    <div className="text-15 mt-10">
                      <ul className="list-disc text-15 mt-10">
                        {cruiseDetails?.response?.cancellationPolicy?.map(
                          (item, index) => (
                            <li key={index} className="policy">
                              {item}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                ) : null}
              </div>
              <div id="decksPlan"></div>
              {cruiseDetails?.response?.deckPlanPhoto ? (
                <section className="col-lg-9 pt-40  layout-pb-lg border-top-light pt-30">
                  <div className="col-12">
                    <div>
                      <div className="row">
                        <div className="col-9">
                          <h3 className="text-22 fw-500">
                            {t("common.decksPlan")}
                          </h3>
                        </div>
                      </div>

                      <div
                        className="row x-gap-50 y-gap-30 pt-20"
                        style={{ width: "auto" }}
                      >
                        <img
                          style={{
                            width: "auto",
                            textAlign: "center",
                            margin: "auto",
                          }}
                          src={cruiseDetails?.response?.deckPlanPhoto}
                          alt={
                            cruiseDetails?.response?.deckNum +
                            " " +
                            t("common.decksPlan")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </section>
              ) : null}
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default CruisesDetails;
